import { AppRouter } from './routing/AppRouter';

export function App() {
  return <AppRouter />;
}
